<div class="table-responsive" *ngIf="levelList">
    <table datatable  [dtOptions]="dtOptions" class="row-border hover table table-striped display compact">
      <thead>
      <tr>
    <td>#</td>
      <td>Name</td>
      <th>Level Short Name</th>
      <th>Ordinal Number</th>
      <th>Country Name</th>
      <th>id</th>
      <th>Description</th>
      </tr>
      </thead>

      <tbody>

      <tr *ngFor="let levelItem of levelList; index as myIndex;">
          <td>{{myIndex}}</td>
          <td>
              <a [routerLink]="['/admin/levels/show/',levelItem['server_level_id']]">
              {{levelItem['name']}}
             </a>
          </td>
          <td>{{levelItem['level_short_name']}}</td>
          <td>{{levelItem['ordinal_number']}}</td>
          <td>
            {{levelItem['level_country_name']}}
          </td>
          <td>{{levelItem['server_level_id']}}</td>
          <td>{{levelItem['description']}}</td>
      </tr>
      </tbody>

  </table>
  </div>


  <div *ngIf="!levelList" class="text-center">
    No levels found
  </div>
